import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterlogs'
})
export class FilterPipeLogs implements PipeTransform {
    transform(logs: any, term?: any): any {
        if (term === undefined) return logs;
        if (term === null) return logs;

        if (logs != null) {
            return logs.filter(function (log) {
                if (log.category != undefined)
                    if (log.category.toString().toLowerCase().includes(term.toLowerCase()))
                        return log;
                if (log.page != undefined)
                    if (log.page.toString().toLowerCase().includes(term.toLowerCase()))
                        return log;
                if (log.user != undefined)
                    if (log.user.toString().toLowerCase().includes(term.toLowerCase()))
                        return log;
                if (log.rol != undefined)
                    if (log.rol.toString().toLowerCase().includes(term.toLowerCase()))
                        return log;
                if (log.date != undefined)
                    if (log.date.toString().toLowerCase().includes(term.toLowerCase()))
                        return log;

            })
        }

    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-logs/filter.pipe.ts